var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","max-width":_vm.maxWidth,"color":"grey darken-4"},scopedSlots:_vm._u([(_vm.text)?{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"e-info-icon",attrs:{"color":_vm.color,"dark":"","size":_vm.size}},'v-icon',attrs,false),on),[_vm._v("\n      info\n    ")])]}}:null],null,true)},[_vm._v(" "),_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }